import React from 'react';
import { Badge } from 'react-bootstrap';

type Props = {
  label: string;
};

export const SkillOptionLabel: React.FC<React.PropsWithChildren<Props>> = ({
  label,
}) => (
  <Badge bg="light" className="fs-base">
    {label}
  </Badge>
);
